import { SVGProps } from 'react'
const CommunityIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={36}
    height={36}
    className={className}
    {...props}
  >
    <path
      d="M30 23.3v-16H6v16h24m0-18.6c1.5 0 2.7 1.2 2.7 2.7v16c0 1.5-1.2 2.7-2.7 2.7h-9.3v2.7h2.7v2.7H12.7v-2.7h2.7V26H6c-1.5 0-2.7-1.2-2.7-2.7v-16c0-1.5 1.2-2.7 2.7-2.7h24M8.7 10h12v6.7h-12V10M22 10h5.3v2.7H22V10m5.3 4v6.7H22V14h5.3M8.7 18H14v2.7H8.7V18m6.6 0h5.3v2.7h-5.3V18z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
)
export default CommunityIcon
